import type { QueryClient } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";
import { EnterpriseApiError } from "../api/enterpriseClient";
import { customerContextQueryOptions } from "../queries/useGetCustomerContext";

export async function ensureEnterpriseCustomerContext(
  queryClient: QueryClient,
  externalCustomerId: string,
) {
  try {
    return await queryClient.ensureQueryData(
      customerContextQueryOptions(externalCustomerId),
    );
  } catch (error) {
    if (
      error instanceof EnterpriseApiError &&
      error.status === 404 &&
      error.operation === "customer-context"
    ) {
      throw redirect({ to: "/" });
    }

    throw error;
  }
}
